import { sendGenerateAIQuestionsEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface GenerateAIQuestionsEventAdapterParams {
  numQuestions: number;
  multipleChoice: boolean;
  trueFalse: boolean;
  shortAnswer: boolean;
  includeExplanation: boolean;
  promptLength: number;
  version: string;
  responseMilliseconds: number;
  promptTokens: number;
  completionTokens: number;
  totalTokens: number;
}

export class GenerateAIQuestionsEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendGenerateAIQuestionsEvent;
  protected intercomEventKey = 'generate_ai_questions';

  constructor({
    numQuestions,
    multipleChoice,
    trueFalse,
    shortAnswer,
    includeExplanation,
    promptLength,
    version,
    responseMilliseconds,
    promptTokens,
    completionTokens,
    totalTokens,
  }: GenerateAIQuestionsEventAdapterParams) {
    super();

    try {
      this.eventData = {
        num_questions: numQuestions,
        question_multiple_choice: multipleChoice,
        question_true_false: trueFalse,
        question_short_answer: shortAnswer,
        include_explanation: includeExplanation,
        prompt_length: promptLength,
        version: version,
        response_milliseconds: responseMilliseconds,
        prompt_tokens: promptTokens,
        completion_tokens: completionTokens,
        total_tokens: totalTokens,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
